export default __webpack_public_path__ + "static/media/Data privacy.92f3e906.png";